export default __webpack_public_path__ + "static/media/constanz.c06e906f.ttf";